export const getProducts = (state) => state.data.lists.products.items
export const isProductsLoaded = (state) => state.data.lists.products.loaded
export const isLoadingProducts = (state) => state.data.lists.products.loading
export const getProductOptions = state => state.data.lists.products.options
